import { ContactPerson } from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { hasText } from 'shared/lib/common-util'
import { PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import { RuleResult } from 'types/DeclarationP5'

const CustomValidators = {
  validateContactPersonNameAndPhoneRequirement: (
    contactPerson?: { name: string; telephone: string; email: string } | null,
  ): boolean => {
    if (!contactPerson) return false
    return (hasText(contactPerson.name) || hasText(contactPerson.telephone) || hasText(contactPerson.email))
  },
  validateTraderPartyContactPersonPhoneRequirement: (contactPerson: ContactPerson | undefined | null): boolean => {
    if (!contactPerson) return false
    return (hasText(contactPerson.telephone) || hasText(contactPerson.email))
  },
  validateConsignmentConsigneeContactPersonRequirement: (formData: { security: string }): RuleResult => {
    if (!['1', '3'].includes(formData.security)) return 'NOT_ALLOWED'

    return 'REQUIRED'
  },

  // NES01
  validateTransportDocumentReferenceNumberRequirement: (
    documentType: string,
    country: string,
  ) => (['N355', 'N337', 'N785'].includes(removePrefix(documentType, PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX) ?? '') && ['EE', 'FI'].includes(country)),
}

export default CustomValidators
